"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconPhone = _interopRequireDefault(require("../../../shared/icons/icon-phone.svg"));

var _iconEnvelope = _interopRequireDefault(require("../../../shared/icons/icon-envelope.svg"));

var _iconArrowOut = _interopRequireDefault(require("../../../shared/icons/icon-arrow-out.svg"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var iconMap = {
  Phone: _iconPhone["default"],
  Email: _iconEnvelope["default"],
  Web: _iconArrowOut["default"]
};
/* eslint-disable camelcase */

var Contact = function ContactComponent(_ref) {
  var dataClient = _ref.dataClient,
      contact_type = _ref.contact_type,
      contact_label = _ref.contact_label,
      contact_link_text = _ref.contact_link_text,
      contact_link_url = _ref.contact_link_url;
  var Icon = iconMap[contact_type];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "program-contact"
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    className: "program-contact__icon"
  }), contact_label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "program-contact__label"
  }, "".concat(dataClient.renderText(contact_label), " ")), /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
    className: "program-contact__link",
    href: contact_link_url.url,
    external: contact_link_url.target === '_blank'
  }, dataClient.textToMarkdown(contact_link_text)));
};

Contact.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  contact_type: _propTypes["default"].string.isRequired,
  contact_link_text: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  contact_link_url: _propTypes["default"].shape({}).isRequired,
  contact_label: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
Contact.defaultProps = {
  contact_label: undefined
};
var _default = Contact;
exports["default"] = _default;